module.exports = __webpack_public_path__ + "img/seekingsimple2.82e26d4c.png";